import { IDanhSachDuDieuKienThucTapResponse } from "../../../model/response/xet-thuc-tap/IDanhSachDuDieuKienThucTapResponse";
import { IDanhSachDuDieuKienThucTapViewModel } from "../../../model/response/xet-thuc-tap/IDanhSachDuDieuKienThucTapViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachDuDieuKienThucTapActionsObj = {
    LOAD_BY_DOT_THUC_TAP_START: 0,
    LOAD_BY_DOT_THUC_TAP_SUCCESS: [] as IDanhSachDuDieuKienThucTapViewModel[],
    LOAD_BY_DOT_THUC_TAP_ERROR: "",

    LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_START: 0,
    LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_SUCCESS: {} as IDanhSachDuDieuKienThucTapResponse,
    LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR: "",

    CHUYEN_KHONG_DU_DIEU_KIEN_START: {} as { id: number, id_dot_thuc_tap: number },
    CHUYEN_KHONG_DU_DIEU_KIEN_SUCCESS: undefined,
    CHUYEN_KHONG_DU_DIEU_KIEN_ERROR: "",
}

export const eDanhSachDuDieuKienThucTapActionIds = generateActionTypeIds(eDanhSachDuDieuKienThucTapActionsObj, "DANH_SACH_DU_DIEU_KIEN_THUC_TAP");
export type IDanhSachDuDieuKienThucTapActionTypes = IGenericActionType<typeof eDanhSachDuDieuKienThucTapActionsObj, "DANH_SACH_DU_DIEU_KIEN_THUC_TAP">;